interface ZoomControlsProps {
  zoom: number;
  onZoom: (delta: number) => void;
  onCenter: () => void;
}

export function ZoomControls({ zoom, onZoom, onCenter }: ZoomControlsProps) {
  return (
    <div className="absolute right-3 bottom-3 z-10 flex flex-col gap-2">
      <button
        className="w-10 h-10 rounded-full glass text-white text-xl flex items-center justify-center active:scale-95"
        onClick={() => onZoom(0.2)}
        aria-label="Zoom in"
      >
        +
      </button>
      <div className="text-center text-[10px] text-white/60 font-medium tabular-nums">
        {Math.round(zoom * 100)}%
      </div>
      <button
        className="w-10 h-10 rounded-full glass text-white text-xl flex items-center justify-center active:scale-95"
        onClick={() => onZoom(-0.2)}
        aria-label="Zoom out"
      >
        −
      </button>
      <button
        className="w-10 h-10 rounded-full glass text-white text-base flex items-center justify-center active:scale-95 mt-2"
        onClick={onCenter}
        aria-label="Center on player"
      >
        🎯
      </button>
    </div>
  );
}
